$('.mus-ou-file-include').each(function () { 
$.ajax({context: this, url: 'http://a.cms.omniupdate.com/files/info?site=' + $(this).data('site') + '&path=' + encodeURIComponent($(this).data('filepath'))}).done( function(result) {
	$.ajax({context: this, url: result.info.http_path}).done( function(result) {
		$(this).html(result);
	});
})
});